module.exports = __webpack_public_path__ + "img/quality.05197fe0.png";